import * as z from "zod";
import { decode } from "./decode.js";
const PrismicConfigPluginRegistrationSchema = z.union([
  z.string(),
  z.object({
    resolve: z.string(),
    options: z.record(z.string(), z.unknown()).optional()
  })
]);
const PrismicConfigSchema = z.object({
  repositoryName: z.string(),
  adapter: PrismicConfigPluginRegistrationSchema,
  apiEndpoint: z.string().optional(),
  libraries: z.array(z.string()).optional()
});
const decodePrismicConfig = (input) => {
  return decode(PrismicConfigSchema, input);
};
export {
  decodePrismicConfig
};
//# sourceMappingURL=decodePrismicConfig.js.map
